import {Avatar, Box} from "@material-ui/core";
import React, {FC, useContext} from "react";
import {useTranslate} from "@tolgee/react";
import formatExtraProductName from "tools/formats/formatExtraProductName";
import formatPrice from "tools/formats/formatPrice";
import {ExtraProduct, FullProduct} from "ts/api/product";
import {CurrencyContext} from "view/context/CurrencyContext";
import {useMergedProductDiscountCodes} from "view/apps/Exhibitor/pages/Cart/helpers/useMergedProductDiscountCodes";
import FlexBox from "view/components/Layout/FlexBox";
import CartDiscountCodes from "view/components/ShoppingCart/components/ProductItem/DiscountCode";
import ElipsisWrapper from "view/components/DataRow/ElipsisWrapper";
import {useProductFiles} from "store/custom-product-option/selectors";
import {findOptionImageUrl} from "tools/product/image/findOptionImageUrl";
import {useStyles} from "./style";

type Props =
  | {
      product: ExtraProduct;
      isExtra: true;
    }
  | {
      product: FullProduct;
      isExtra?: false;
    };

const SupplierProductRow: FC<Props> = ({product, isExtra}) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const currency = useContext(CurrencyContext);
  // Filled by the cart step, which the payment step always comes after.
  const productImages = useProductFiles(
    isExtra ? "" : product.owner.id,
    isExtra ? "" : product.id
  );
  const avatarSrc = isExtra
    ? undefined
    : findOptionImageUrl(productImages, product.imageId) ||
      product.image?.signedUrl;
  const quantity = (isExtra ? product.quantity : product.cartQuantity) || 1;
  const quantityLabel = t("exhibitor.cart.bank_transfer.item_count", {
    count: quantity,
  });
  const productDiscountCodes = useMergedProductDiscountCodes(
    isExtra ? [] : product.discountCodes
  );

  return (
    <FlexBox column gap={1} fullWidth>
      <Box className={classes.root}>
        <Box className={classes.content}>
          {avatarSrc && (
            <Avatar
              variant="rounded"
              src={avatarSrc}
              className={classes.avatar}
            />
          )}
          <Box className={classes.productName}>
            <ElipsisWrapper
              value={
                isExtra ? formatExtraProductName(product.name) : product.name
              }
            />
          </Box>
        </Box>
        <Box className={classes.numbers} justifyContent="end">
          <Box className={classes.numberCell}>{quantityLabel}</Box>
          <Box className={classes.numberCell}>
            {formatPrice(product.priceWithFees * quantity, currency)}
          </Box>
        </Box>
      </Box>
      {!!productDiscountCodes.length && (
        <CartDiscountCodes discountCodes={productDiscountCodes} />
      )}
    </FlexBox>
  );
};
export default SupplierProductRow;
